import { Button, css, styled } from "@mui/material";
import { default as styledComp } from "styled-components";
export const LoadingContainer = styledComp.div`
  display:flex;
  justify-content: center;
  margin: 15px 0;
`;

export const ButtonStyled = styled(Button)`
  transition: filter 0.3s;
  text-transform: none;
  ${(props) =>
    props.variant === "outlined"
      ? css`
        font-weight: normal;
        `
      : undefined}

  color: ${(props) => props.theme.palette.primaryFont.main};

  :hover {
    filter: brightness(1.2);
  }

  :disabled {
    opacity: 0.6;
    pointer-events: none;
  }
`;
